export const virtualTerminals = [
  { id: '5C66', name: 'AU THDPTY CHEVRON KALGOORLIE' },
];

export const getVirtualTerminalNameById = (id) => {
  const terminal = virtualTerminals.find((terminal) => terminal.id === id);
  return terminal ? terminal.name : null;
}